import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import classnames from 'classnames';

import OutlinedTextField from '../../shared/Fields/OutlinedTextField.js';
import SimpleSelect from '../../shared/Selects/SimpleSelect.js';
import mapListToOptions from '../../../helpers/mapListToOptions.js';
import { doctypes } from '../../../constants/enums.js';
import { Formik } from 'formik';
import { validationSchema } from './QueryQuotaNoHolderValidation';
import CustomDialog from '../../shared/Modals/CustomDialog.js';
import formatMoney from '../../../helpers/formatMoney.js';
import CollapseWrapper from '../../shared/CollapseWrapper.js';

import combineStyles from '../../../helpers/combineStyles.js';
import LayoutStyles from '../../../styles/layout.js';
import ButtonStyles from '../../../styles/button.js';
import TypographyStyles from '../../../styles/typography.js';
import SpacingStyles from '../../../styles/helpers/spacing.js';
import ListsStyle from '../__styles__/Lists.style.js';
import OurDatePicker from '../../shared/CustomDatePicker';
import QuotaNoHolder from './QuotaNoHolder.js';

class QueryQuotaNoHolder extends PureComponent {
  onSubmit = values => {
    this.props.queryQuotasNoHolder(values);
  };

  _handleOnClose = () => {
    this.props.resetQueryData();
    this.props.closeModal();
  };

  resetForm = () => { };

  _onKeyPress = event => {
    event.key === 'Enter' && event.preventDefault();
  };

  renderResponse() {
    const {
      serverErrors = {},
      quotas,
      generalWarrantyCaseThreeCategoriesConfig,
      categories
    } = this.props;

    const errorMessage = serverErrors.base || serverErrors.contract;

    if (errorMessage) {
      return (
        <div style={{ marginTop: 15 }}>
          <strong>Observaciones</strong>
          <ul>
            <li><p>{errorMessage}</p></li>
          </ul>
        </div>
      );
    }

    const megaQuotaValue = quotas.megaQuotas[0].quota;
    const [lowCategoryConfig, highCategoryConfig] = generalWarrantyCaseThreeCategoriesConfig;

    const usedQuota = quotas.usedQuota + quotas.usedQuotaByClient;
    const availableQuota = Math.max(Math.min(highCategoryConfig.max_value, megaQuotaValue) - usedQuota, 0);
    const availableLowCategoryQuota = Math.max(Math.min(lowCategoryConfig.max_value, megaQuotaValue) - usedQuota, 0);

    if (availableQuota <= 0 && availableLowCategoryQuota <= 0) {
      return (
        <div style={{ marginTop: 15 }}>
          <strong>Observaciones</strong>
          <ul>
            <li><p>Cliente no aplica para venta a no titular sin codeudor</p></li>
          </ul>
        </div>
      );
    }

    return (
      <div>
        <br></br>
        <QuotaNoHolder
          serverErrors={serverErrors}
          availableQuota={availableQuota}
          availableLowCategoryQuota={availableLowCategoryQuota}
          caseThreeConfig={generalWarrantyCaseThreeCategoriesConfig}
          categories={categories}
        />
      </div>
    );
  }

  render() {
    const {
      classes,
      loading,
      serverErrors = {},
      quotas = [],
      isOpen,
      hasSearched,
    } = this.props;
    const successfulRequest = hasSearched && _isEmpty(serverErrors);

    return (
      isOpen && (
        <Formik
          initialValues={{
            contract: '',
            identificationType: doctypes[0].value,
            identification: '',
            debtorBirthday: null,
            debtorDocumentExpeditionDate: null
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            this.resetForm = resetForm;
            this.onSubmit(values);
          }}
          onReset={(_, actions) => {
            actions.resetForm();
            this._handleOnClose();
          }}
          render={({
            values,
            errors,
            touched,
            handleSubmit,
            handleChange,
            handleReset,
            setFieldValue,
          }) => (
            <CustomDialog
              onClose={handleReset}
              onConfirm={handleSubmit}
              onConfirmSecond={() => {
                this.props.resetQueryData();
                this.resetForm();
              }}
              loading={loading}
              open={isOpen}
              title={'Consulta de Cupo No Titulares Sin Codeudor'}
              buttonText={'Consultar'}
              disabled={Object.keys(errors).length > 0 ? true : false}
              disableBackdropClick={true}
              classes={{
                root: classes.queryQuotaDialogRoot,
                content: classes.queryQuotaDialogContent
              }}
            >
              <form autoComplete="off" className={classes.form}>
                <Grid container spacing={24} alignItems="flex-start">
                  <Grid item sm={6} xs={12} className={classes.inputGrid}>
                    <OutlinedTextField
                      onKeyPress={this._onKeyPress}
                      disabled={loading}
                      label="Número de contrato:"
                      name="contract"
                      type={'number'}
                      error={
                        (touched.contract && !!errors.contract) ||
                        !!_get(serverErrors, 'errors.contract')
                      }
                      helperText={
                        (touched.contract && errors.contract) ||
                        _get(serverErrors, 'errors.contract')
                      }
                      value={values.contract}
                      onChange={handleChange}
                    />
                  </Grid>
                  <React.Fragment>
                    <Grid item sm={6} xs={12} className={classes.inputGrid}>
                      <SimpleSelect
                        disabled={true}
                        value={values.identificationType}
                        onChange={handleChange}
                        name="identificationType"
                        label="Tipo de identificación del deudor:"
                        options={mapListToOptions(doctypes, {}, true)}
                      />
                    </Grid>
                    <Grid item sm={6} xs={12} className={classes.inputGrid}>
                      <OutlinedTextField
                        onKeyPress={this._onKeyPress}
                        disabled={loading}
                        type={'number'}
                        label="Identificación del deudor:"
                        name="identification"
                        error={
                          (touched.identification &&
                            !!errors.identification) ||
                          (serverErrors && !!serverErrors.debtor)
                        }
                        helperText={
                          (touched.identification &&
                            errors.identification) ||
                          (serverErrors && serverErrors.debtor)
                        }
                        value={values.identification}
                        onChange={handleChange}
                      />
                    </Grid>
                  </React.Fragment>
                </Grid>
                {hasSearched && (
                  <Grid xs={12}>
                    {this.renderResponse()}
                  </Grid>
                )}
              </form>
            </CustomDialog>
          )}
        />
      )
    );
  }
}

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: 0
  },
  notFound: {
    marginTop: 10,
    color: 'red'
  },
  dataContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: '5px 0px'
  },
  dataColumn: {
    width: '50%',
    ['@media (max-width:600px)']: {
      width: '100% !important'
    }
  },
  dataRegister: {
    margin: '2.5px 0px'
  },
  observationsList: {
    paddingLeft: 30
  },
  extraQuotaItem: {
    borderTop: 'solid 1px #BCBCBC',
    padding: 10,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:last-child': {
      borderBottom: 'solid 1px #BCBCBC'
    }
  },
  queryResults: {
    marginTop: 10,
    display: 'block',
    width: '100%'
  },
  insurance: {
    margin: '2% 0 2% 0',
    flex: 1
  },
  resultContainer: {
    minHeight: 50,
    width: '100%',
    display: 'block',
    backgroundColor: '#FFF',
    borderRadius: '2px',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    marginBottom: theme.spacing.unit * 2,
    padding: '10px 16px'
  },
  spacer: {
    flex: 1,
    minHeight: '1px',
    minWidth: '1px'
  },
  button: {
    marginRight: 0,
    padding: '6px 8px',
    width: 100
  },
  queryQuotaDialogRoot: {
    ['@media (max-width:600px)']: {
      width: '95%',
      margin: '0 24px'
    }
  },
  queryQuotaDialogContent: {
    overflowX: 'hidden',
    overflowY: 'auto'
  },
  inputGrid: {
    padding: '6px 12px 6px 12px !important',
    ['@media (max-width:600px)']: {
      padding: '0 12px !important'
    }
  },
  grayContainer: {
    backgroundColor: '#EFF1F4',
    marginBottom: '5%',
    padding: 20
  },
  title: {
    color: '#111'
  }
});

QueryQuotaNoHolder.propTypes = {
  classes: PropTypes.object.isRequired,
  newAlert: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

export default withStyles(
  combineStyles(
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles,
    ListsStyle,
    styles
  )
)(QueryQuotaNoHolder);
